export default {
  add_items: 'Lisää tuotteita',
  remove_items: 'Poista tuotteita',
  place_order: 'Tee tilaus',
  proceed_to_payment: 'Siirry maksamaan',
  go_to_menu: 'Siirry valikkoon',

  toasts: {
    input_errors_found: 'Tilaustiedoissasi on ongelmia',
  },

  error_messages: {
    internal_error: {
      title: 'Tilaus epäonnistui 😔',
      description:
        'Valitettavasti tilauksessasi tapahtui odottamaton ongelma, tekninen tiimimme työskentelee jo asian parissa 🛠️.',
    },
  },
};
